export default {
  options: {
    none: 'Geen promotiecode om te beginnen',
  },
  buttons: {
    next: 'Volgende',
    back: 'Terug',
    skip: 'Overslaan',
  },
};
